import { QuoteHandlerFactory } from "../lib/QuoteHandlerFactory";
import { MetricType } from "../lib/types/MetricType";
import { QuoteLoadPayload } from "../lib/types/QuoteLoadPayloadType";
import { QuoteType } from "../lib/types/QuoteType";
import { CalculationType, QuotingType } from "../state/quote-reducer";

export class QuoteService {
  public static loadQuoteByType(
    quoteType: QuoteType,
    id: number
  ): Promise<QuoteLoadPayload> {
    return QuoteHandlerFactory.getQuoteInstance(quoteType).load(id);
  }

  public static calculateQuoteByType(
    quoteType: QuoteType,
    quote: QuotingType,
    id: number | null
  ): Promise<Partial<QuoteLoadPayload>> {
    return QuoteHandlerFactory.getQuoteInstance(quoteType).calculate(quote, id);
  }

  public static saveQuoteByType(
    id: number,
    quoteType: QuoteType,
    quote: QuotingType,
    calculation: CalculationType,
    isCopy: boolean
  ): Promise<Partial<QuoteLoadPayload>> {
    if (isCopy) {
      return QuoteHandlerFactory.getQuoteInstance(quoteType).copy(
        quote,
        calculation
      );
    }

    if (id) {
      return QuoteHandlerFactory.getQuoteInstance(quoteType).update(
        id,
        quote,
        calculation
      );
    }

    return QuoteHandlerFactory.getQuoteInstance(quoteType).save(
      quote,
      calculation
    );
  }

  public static submitQuoteByType(
    id: number,
    quoteType: QuoteType,
    quote: QuotingType,
    calculation: CalculationType,
    submitForReview: boolean
  ): Promise<boolean> {
    if (submitForReview) {
      return QuoteHandlerFactory.getQuoteInstance(quoteType).submitForReview(
        id,
        quote,
        calculation
      );
    }

    return QuoteHandlerFactory.getQuoteInstance(quoteType).submit(
      id,
      quote,
      calculation
    );
  }

  public static saveMetricByType(
    id: number | null,
    metric: MetricType,
    quoteType: QuoteType,
    quote: QuotingType,
    calculation: CalculationType
  ): Promise<void> {
    return QuoteHandlerFactory.getQuoteInstance(quoteType).saveMetric(
      id,
      metric,
      quote,
      calculation
    );
  }
}
